import { render, staticRenderFns } from "./firstCardAllAlert.vue?vue&type=template&id=50c42cde&scoped=true"
import script from "./firstCardAllAlert.vue?vue&type=script&lang=js"
export * from "./firstCardAllAlert.vue?vue&type=script&lang=js"
import style0 from "./firstCardAllAlert.vue?vue&type=style&index=0&id=50c42cde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c42cde",
  null
  
)

export default component.exports